/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_u1h_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Checking a slow-cooked or braised dish at hourly intervals.`)
};

const es_timer_u1h_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revisar un plato cocinado a fuego lento o guisado a intervalos de una hora.`)
};

const de_timer_u1h_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein Schmor- oder Braisiergericht im Stundentakt kontrollieren.`)
};

const nl_timer_u1h_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een langzaam gegaard of gestoofd gerecht elk uur controleren.`)
};

const fr_timer_u1h_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vérifier un plat en cuisson lente ou braisé à intervalles horaires.`)
};

const it_timer_u1h_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Controllare un piatto a cottura lenta o brasato a intervalli di un'ora.`)
};

const pt_br2_timer_u1h_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Checar um prato cozido em fogo baixo ou refogado em intervalos de uma hora.`)
};

const pt_timer_u1h_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verificar um prato de cozedura lenta ou estufado a intervalos de uma hora.`)
};

const ja_timer_u1h_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`低温調理や煮込み料理を1時間ごとに確認する。`)
};

const zh_timer_u1h_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每隔一小时查看一次慢炖或炖煮的菜肴。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_u1h_use3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_u1h_use3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_u1h_use3", locale)
	if (locale === "en") return en_timer_u1h_use3(inputs)
	if (locale === "es") return es_timer_u1h_use3(inputs)
	if (locale === "de") return de_timer_u1h_use3(inputs)
	if (locale === "nl") return nl_timer_u1h_use3(inputs)
	if (locale === "fr") return fr_timer_u1h_use3(inputs)
	if (locale === "it") return it_timer_u1h_use3(inputs)
	if (locale === "pt-BR") return pt_br2_timer_u1h_use3(inputs)
	if (locale === "pt") return pt_timer_u1h_use3(inputs)
	if (locale === "ja") return ja_timer_u1h_use3(inputs)
	return zh_timer_u1h_use3(inputs)
};